import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Container } from 'react-bootstrap';

import PalavraBloqueadaCadastro from './PalavraBloqueadaCadastro';

import Button from '../../components/Button';

import ListaPalavraBloqueadas from './ListaPalavrasBloqueadas';
import { TIPO_USUARIO } from '../../utils/funcoes';

import { useAuth } from '../../hooks/auth';

export interface IPalavraBloqueada {
  id: number;
  palavra: string;
}

const PalavraBloqueada: React.FC = () => {
  const history = useHistory();
  const { user } = useAuth();

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.SUPERVISOR) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  const [showModalCadastro, setShowModalCadastro] = useState(false);
  const [
    palavraBloqueadaSelecionado,
    setPalavraBloqueadaSelecionado,
  ] = useState<IPalavraBloqueada | undefined>(undefined);

  return (
    <Container fluid className="mt-2">
      <div className="bg-white border p-2 mb-2">
        <div className="d-flex justify-content-between mb-2">
          <h2 id="topoBusca">Palavras Bloqueadas</h2>
          <div>
            <Button
              type="button"
              variant="success"
              onClick={() => {
                setPalavraBloqueadaSelecionado(undefined);
                setShowModalCadastro(!showModalCadastro);
              }}
            >
              {showModalCadastro
                ? 'Voltar para Lista'
                : 'Nova Palavra Bloqueada'}
            </Button>
          </div>
        </div>
        <span>
          As palavras cadastradas aqui serão filtradas e apagadas na tela de
          atendimento do médico na listagem de procedimentos
        </span>
      </div>
      <div className="bg-white border p-2">
        {showModalCadastro && (
          <PalavraBloqueadaCadastro
            setShowModal={setShowModalCadastro}
            palavra={palavraBloqueadaSelecionado}
          />
        )}
        {!showModalCadastro && (
          <ListaPalavraBloqueadas
            setShowModal={setShowModalCadastro}
            showModal={showModalCadastro}
            setPalavraSelecionada={setPalavraBloqueadaSelecionado}
          />
        )}
      </div>
    </Container>
  );
};

export default PalavraBloqueada;
